var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "History/history_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87953 3.27388C4.20659 1.84047 6.07765 1.00282 8.056 1.00282C11.9468 1.00282 15.112 4.168 15.112 8.05882C15.112 11.9496 11.9468 15.1148 8.056 15.1148C4.16518 15.1148 1 11.9496 1 8.05882H1.94118C1.94118 11.4301 4.68471 14.1736 8.056 14.1736C11.4273 14.1736 14.1708 11.4301 14.1708 8.05882C14.1708 4.68753 11.4273 1.944 8.056 1.944C6.38447 1.944 4.80329 2.63765 3.65976 3.82353H5.70306V4.76471H1.93835V1H2.87953V3.27388ZM7.58541 8.05882V4.76471H8.52659V7.69365L10.2856 9.61929L9.59106 10.2546L7.58541 8.05882Z",
    fill: "#2495F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory16);
export default __webpack_public_path__ + "static/media/history_16.71f6a396445e40b150896bfad9593f55.svg";
export { ForwardRef as ReactComponent };